import { ChevronRight } from 'lucide-react';
import { useDocsStore } from '../../stores/docsStore';

interface DocsBreadcrumbProps {
  path: string;
}

export function DocsBreadcrumb({ path }: DocsBreadcrumbProps) {
  const { roots, activeRoot, expandDirectory, selectFile } = useDocsStore();

  const root = roots.find(r => r.id === activeRoot);
  const rootPath = root?.path || '/opt/union-threads/';
  const rootLabel = root?.label || 'Union Threads';

  // Get relative path from root
  const relative = path.replace(rootPath, '');
  const segments = relative.split('/').filter(Boolean);

  const handleSegmentClick = (index: number) => {
    // Build path up to this segment
    let targetPath = rootPath;
    for (let i = 0; i <= index; i++) {
      targetPath += segments[i] + '/';
    }

    // If clicking the last segment (the file), do nothing
    if (index === segments.length - 1 && !path.endsWith('/')) return;

    expandDirectory(targetPath);
  };

  return (
    <div className="flex items-center gap-1 text-xs text-text-muted overflow-x-auto flex-nowrap min-w-0">
      <span className="text-text-secondary flex-shrink-0">{rootLabel}</span>
      {segments.map((segment, i) => {
        const isLast = i === segments.length - 1;
        return (
          <span key={i} className="flex items-center gap-1 flex-shrink-0">
            <ChevronRight className="h-3 w-3 text-text-muted" />
            {isLast ? (
              <span className="text-text-primary font-medium">{segment}</span>
            ) : (
              <button
                onClick={() => handleSegmentClick(i)}
                className="text-text-secondary hover:text-accent-purple-light transition-colors"
              >
                {segment}
              </button>
            )}
          </span>
        );
      })}
    </div>
  );
}

export default DocsBreadcrumb;
